import classNames from "classnames";
import { ReactNode } from "react";

import Label from "../Label/Label";

import styles from "./HeroSplit.module.css";

const HeroSplit: React.FC<HeroSplitProps> = ({
  className,
  title,
  titleAs: TitleComponent = "h1",
  label,
  labelAs: LabelComponent = "span",
  image,
  imageOverlayText,
  children,
  invert,
}) => {
  return (
    <div
      className={classNames(
        styles.hero,
        { [styles.heroInvert]: invert },
        className
      )}
    >
      <div className={classNames(styles.heroWrap, "grid")}>
        <div className={styles.imageWrap}>
          {image}
          {imageOverlayText && (
            <span className={styles.imageOverlayText}>{imageOverlayText}</span>
          )}
        </div>
        <div className={styles.content}>
          {label && (
            <LabelComponent className={styles.label}>
              <Label>{label}</Label>
            </LabelComponent>
          )}
          <TitleComponent className={styles.title}>{title}</TitleComponent>
          {children}
        </div>
      </div>
    </div>
  );
};

type HeroSplitProps = {
  children?: ReactNode;
  className?: string;
  label?: string;
  labelAs?: keyof JSX.IntrinsicElements;
  title: string;
  titleAs?: keyof JSX.IntrinsicElements;
  image: ReactNode;
  imageOverlayText?: string;
  invert?: boolean;
};

export const imageSizes = "(max-width: 1024px) 100vw, 600px";

export default HeroSplit;
